import React from "react";
import { SupplierImportTable } from "../component/supplierImportCSV/SupplierImportTable";

export const SupplierPage = () => {
  return (
    <>
      <SupplierImportTable />
    </>
  );
};
